module.exports = __webpack_public_path__ + "img/result_head_left.21450327.png";